import { all } from 'async-saga';
import { selectCall, selectEndpoint, selectLine, webrtcActions } from 'webrtc-client-janus';
import { actions } from '..';
import { getFormatedNumber, startDesktopMonitor } from '../../api';
import { answer, blindTransfer, changePriority, createJitsiCallRequest, dial, hangup, pickup, queuehold, queuePickup, queueResume, retrieveVoicemail, superTransfer } from '../../api/call-control';
import { killMedia } from '../../api/queue-control';
import { IpcRenderSend } from '../../Electron/ipcRenderer';
import { activeCallCount } from '../../Components/CallPopup';
import { GetCallControl } from '../../Components/MainToolbarDialButton';
import { IpfxMobiltiyClientSend, WebViewAction } from '../../mobility-client-api';
import { ClidObjectType, DeviceGroupType, DeviceType, ExtensionStatus, sameIdentifier } from '../../model';
import { delay } from '../../promise-utils';
import { getActiveDevice, selectActiveDevice } from '../reducers';
import { selectApplicationSetting, selectConfigProp, selectMyAccess, selectMyData, selectMyDevices, selectMyself } from '../reducers/config';
import { getParkedMedia, selectInIpfxClient, selectInIpfxMobility } from '../reducers/localSettings';
import { selectHeldCall, selectMedia, selectMyActiveCall, selectMyCalls, selectQueueHeldCall } from '../reducers/media';
import { selectExtension } from '../reducers/queueAgents';
import { JitsiResult } from '../reducers/settings';
import { take, takeEvery, waitForState } from '../tools/async-saga-types';
import { IpcRenderShowMainWindow } from '../../Electron/ipcCommands';

const ccHoldAndRetrieve = takeEvery(actions.ccHoldAndRetrieve, async function (ctx, { device, hold, retrieve, me }) {

  queuehold(device, '', hold)
  //wait my extension to go released then then retrieve call
  for (; ;) {
    const { payload: { extension, status } } = await take(ctx, actions.updateExtensionStatus)
    if (sameIdentifier(extension, me) && (
      status === ExtensionStatus.Released || status === ExtensionStatus.None)) {
      retrieveVoicemail(device, retrieve)
      break
    }
  }
})

const ccQueueHold = takeEvery(actions.ccQueueHold, async function (ctx, { device, queue, mediaId, mediaType, timeOut }) {
  ctx.dispatch(actions.setQueueHoldKey(mediaId))
  await queuehold(device, queue, mediaId, (mediaType === 'CALL' || mediaType === 'VM' ? timeOut : '0'))
})

const ccDial = takeEvery(actions.ccDial, async function (ctx, payload) {
  const store = ctx.getState()
  const call = selectCall(store)
  const ipfxMobilityClient = selectInIpfxMobility(store)
  const activeDevice = selectActiveDevice(store)
  const endpoint = selectEndpoint(store)
  const line = selectLine(store)

  if (!activeDevice) return

  if (ipfxMobilityClient) {
    const number = await getFormatedNumber(payload, false, true)

    IpfxMobiltiyClientSend({
      action: WebViewAction.Dial,
      data: number,
    })
  } else {
    if (call != null && call.canDial && endpoint.status === 'online' && line.status === 'registered') {
      const number = await getFormatedNumber(payload, false, true)

      ctx.dispatch(webrtcActions.dial(number))
    } else {
      await dial('', payload)
    }
  }
})

const ccAnswerMedia = takeEvery(actions.ccAnswerMedia, async function (ctx, { media, device }) {
  const store = ctx.getState()
  const myId = selectMyself(store)
  const access = selectMyAccess(store)
  const ipfxClient = selectInIpfxClient(store)
  const teamsEnhancedCti = selectConfigProp(store, 'teamsEnhancedCti')
  const extension = myId && selectExtension(store, myId)
  const auto = selectApplicationSetting(store, 'ExtensionAutoAnswer')
  const view = selectApplicationSetting(store, 'AgentViewOnAnswer')

  let call = selectCall(store)

  if (!myId || !access || !extension || !device || auto === undefined || auto === null) return

  if (ipfxClient && access.isTeamsPbx && !teamsEnhancedCti && extension.deviceGroupType === DeviceGroupType.Other) {
    IpcRenderSend('teams-cti-command', {
      Command: 'answer',
    })
  } else {
    //call assistant && avilable associate
    if (media && media.extensionId !== myId.id) {
      //web rtc CALL
      if (call != null && call.canAnswer && (device.baseType === DeviceType.Softphone || device.baseType === DeviceType.Extension)) {
        ctx.dispatch(webrtcActions.answer())
        //avilable associate has a forwardFrom 
        if (media.forwardFrom !== '') {
          const start = new Date().getTime();
          //wait for connection or 2 seconds
          await waitForState(ctx, s => {
            const c = selectCall(ctx.getState())
            const end = new Date().getTime();
            const diff = end - start;
            const seconds = Math.floor(diff / 1000 % 60);
            return c.status === "connected" || seconds > 5
          })

          //hack to get UI changing correctly
          const x = selectCall(ctx.getState())
          if (x != null && x.status === "connected") {
            ctx.dispatch(actions.updateMediaShowDtmf(media.id, true))
          }
        }
      } else {
        await pickup(myId.id, media.id, auto.value === 'true')
      }
    }
    else if (call != null && call.canAnswer && (device.baseType === DeviceType.Softphone || device.baseType === DeviceType.Extension)) {
      ctx.dispatch(webrtcActions.answer())
    } else {
      await answer(device.number)
    }
  }


  if (ipfxClient && access.isTeamsPbx) {
    IpcRenderShowMainWindow()
  }

  if (media !== null && (!view || view && view.value === 'true')) {
    ctx.dispatch(actions.openAgentView(media.id))
  }
})

const ccHangUp = takeEvery(actions.ccHangUp, async function (ctx, { device }) {
  const call = selectCall(ctx.getState())

  if (call != null && call.canHangUp) {
    ctx.dispatch(webrtcActions.hangUp())
  } else {
    await hangup(device)
  }
})

const ccQueuePickup = takeEvery(actions.ccQueuePickup, async function (ctx, { device, media }) {
  const view = selectApplicationSetting(ctx.getState(), 'AgentViewOnAnswer')
  if (media.length === 0) return

  media.forEach(async x => {
    if (x.mediaType !== 'VM' && x.mediaType !== 'CALL') {
      //set auto answer.   see push-updates 
      await ctx.dispatch(actions.ccSetForAutoAnswer(x.id))
    }

    await queuePickup(device, x.mediaType, x.id, x.queueId, true)

  });

  if ((!view || view && view.value === 'true')) {
    ctx.dispatch(actions.openAgentView(media[0].id))
  }
})

const ccQueueResume = takeEvery(actions.ccQueueResume, async function (ctx, { device, media }) {
  const view = selectApplicationSetting(ctx.getState(), 'AgentViewOnAnswer')

  media.forEach(async x => {
    if (x.mediaType !== 'VM' && x.mediaType !== 'CALL') {
      //set auto answer.   see push-updates 
      await ctx.dispatch(actions.ccSetForAutoAnswer(x.id))
    }
  });

  //request all
  queueResume(device, media.map(m => m.id))

  if ((!view || view && view.value === 'true')) {
    ctx.dispatch(actions.openAgentView(media[0].id))
  }
})

const ccKill = takeEvery(actions.ccKill, async function (ctx, { mediaIds }) {
  mediaIds.forEach(mediaId => {
    const media = selectMedia(ctx.getState(), mediaId)
    if (!media) return

    //this will enable the kill command to complete with the terminate broadcast
    ctx.dispatch(actions.completeMedia(media.id))

    killMedia(media.deviceId, media.id, media.queueId)

  });
})

const ccBlindTransfer = takeEvery(actions.ccBlindTransfer, async function (ctx, payload) {
  await blindTransfer('', payload)
})

const ccSupTransfer = takeEvery(actions.ccSupTransfer, async function (ctx, payload) {
  await superTransfer('', payload)
})

const ccDialConferencePhone = takeEvery(actions.ccDialConferencePhone, async function (ctx, { extension }) {
  const store = ctx.getState()
  const devices = selectMyDevices(store)
  const access = selectMyAccess(store)
  const me = selectMyData(store)

  const calls = selectMyCalls(store)
  const activeCall = selectMyActiveCall(store)
  const activeDevice = selectActiveDevice(store)
  const heldCall = selectHeldCall(store)
  const queueHoldMedia = selectQueueHeldCall(store)
  const parked = getParkedMedia(store)

  const e = selectExtension(store, extension)


  if (!e || !activeCall || !activeDevice || !calls || !devices || !me) return

  const callCount = activeCallCount(calls, devices.devices)

  const control = GetCallControl(activeCall, heldCall, activeDevice, callCount, queueHoldMedia, parked, false,
    {
      access: access,
      mobile: me.mobile,
      associate: me.associate,
      status: e.status,
      canReceiveVoicemail: me.canReceiveVoicemail,
      devices: devices.devices,
    })
  const inSupervisedTransfer = control.cancelTransfer.enabled

  ctx.dispatch(actions.openSmartSearch('conference',
    e.status,
    e.subStatus,
    activeDevice.number,
    inSupervisedTransfer,
    activeCall,
    e.id))
})

const ccCreateVideoConferenceFromCall = takeEvery(actions.ccCreateVideoConferenceFromCall, async function (ctx, { mediaId }) {
  const store = ctx.getState()
  const myId = selectMyself(store)
  const myExtension = myId && selectExtension(store, myId)
  const devices = selectMyDevices(store)
  const call = selectMedia(store, mediaId)

  if (call && myId && myExtension && devices) {
    if (call.clidObjectType === ClidObjectType.extension) {
      ctx.dispatch(actions.ccCreateVideoConferenceFromExtension({ id: call.clidObjectKey, server: myId.server }, mediaId))
    }
  }
})

const ccCreateVideoConferenceFromExtension = takeEvery(actions.ccCreateVideoConferenceFromExtension, async function (ctx, { id, mediaId }) {
  const store = ctx.getState()
  const myId = selectMyself(store)
  const myExtension = myId && selectExtension(store, myId)
  const devices = selectMyDevices(store)
  const call = mediaId && selectMedia(store, mediaId)
  const http = document.location.href.substr(0, document.location.href.toLocaleLowerCase().indexOf('teams'))

  if (myId && myExtension && devices) {

    let extension = selectExtension(store, id)
    if (!extension) {
      ctx.dispatch(actions.fetchExtensionsByIds([id]))
      extension = await waitForState(ctx, s => selectExtension(s, id))
    }

    const name = (extension === undefined) ? 'Unkown' : extension.name

    const jitsiId = await createJitsiCallRequest([id.id])
    ctx.dispatch(actions.requestJitsiStart(jitsiId))

    const response = take(ctx, actions.responseJitsiStart)
    const result = await Promise.race([
      response.then((data) => {
        let x = false
        if (data.payload.id === jitsiId) {
          if (data.payload.response === JitsiResult.Decline) {
            ctx.dispatch(actions.showClientNotification('\'' + name + '\' declined the request'))
            x = true
          } else if (data.payload.response === JitsiResult.Accept) {

            //start video call
            ctx.dispatch(actions.updateJitsiStatus(jitsiId, data.payload.response))
            // hangup call if there is one
            if (call) {
              ctx.dispatch(actions.ccHangUp(getActiveDevice(call, devices.devices, devices.primaryDevice).number, call))
            }

            // response
            window.open(http + '/jitsi?meetingId=' + data.payload.id + '&displayName=' + name + '&showPreJoin=false');
          }
          x = true
        }
        return x
      }),
      delay(10 * 1000).then(() => false),
    ])

    if (!result) {
      ctx.dispatch(actions.showClientNotification('There was no response from \'' + name + '\''))
    }

    ctx.dispatch(actions.requestJitsiClear())
  }
})

const ccMedaiPriorityChange = takeEvery(actions.ccMedaiPriorityChange, async function (ctx, { media }) {
  changePriority(media)
})

const ccRequestMonitorDesktop = takeEvery(actions.ccRequestMonitorDesktop, async function (ctx, { id }) {
  startDesktopMonitor(id)
})

const ccMailto = takeEvery(actions.ccMailto, async function (ctx, { email }) {
  const x = await window.open('mailto:' + email)
  
  if (x && x.open && !x.closed)
  {
    while(x.document.readyState !== "complete"){
      //shit
    }

    setTimeout(() => {
      x.close()    
    }, 100);

    
  }
    
})




export default all(
  ccHoldAndRetrieve,
  ccQueuePickup,
  ccDial,
  ccAnswerMedia,
  ccHangUp,
  ccQueueHold,
  ccQueueResume,
  ccKill,
  ccBlindTransfer,
  ccSupTransfer,
  ccDialConferencePhone,
  ccCreateVideoConferenceFromCall,
  ccCreateVideoConferenceFromExtension,
  ccMedaiPriorityChange,
  ccRequestMonitorDesktop,
  ccMailto,
)
